export class Multimedia {
    constructor(public imgSource: string, public fileName: string, public content: string, public path: string){}
  }